export default __webpack_public_path__ + "static/media/closeRevenue.6ea0671d.svg";